var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2634 8.07581C28.2634 -3.78567 0.244141 0.323817 0.244141 8.07581V17.4156C0.244141 25.1675 6.50177 31.4252 14.2538 31.4252C22.0057 31.4252 28.2634 25.1675 28.2634 17.4156V8.07581Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2046 9.04749L12.4172 17.5179L8.23672 13.4883L5.8479 15.7909L12.4172 22.1231L23.5934 11.3501L21.2046 9.04749Z",
    fill: "#202D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.1b37ee5f1fef3704c6c6efd648433e61.svg";
export { ForwardRef as ReactComponent };